/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { ASSETS, ASSET_MAPPER } from './test-data/dzi.assets';
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const SERVICE_NAME = "dzi.service";
const log: any = LoggerModule.getInstance();

export class DZIService {
    name = SERVICE_NAME;
    private static instance: DZIService;
    private constructor() {
        this.report();
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new DZIService();
        }
        return this.instance;
    }
    async init() { }

    getDzi() {
        return ASSETS ?? [];
    }

    getItem(index: number) {
        if (ASSET_MAPPER[index]) {
            return ASSET_MAPPER[index];
        }
        return null;
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}